import Layout from './Layout.view';

export default Layout;
